export const enum UrlParams {
    Banniere = "banniere",
    Magasin = "mag",
    Division = "div",
    Section = "section",
    Fournisseur = "four",
    Statut = "statut",
    Activite = "act",
    Acheteur = "acht",
    Collection = "coll"
};